import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Dropdown from 'flarum/common/components/Dropdown';
import Button from 'flarum/common/components/Button';
// v0.17.36 — 顶部头像 (v0.6.64 加的 <Avatar user={app.session.user} />) 连同 .ZS-header 一起删除,
//   头像改 Flarum Avatar 的做法本身没错, 只是页内那个头像与全局顶栏 .Button--user 重复且点不动
//   (不是 <a> 也不是 <button>), 桌面端零功能损失。其它地方的 <Avatar> 用法不受影响,
//   本文件不再 import Avatar (下方 tab row 结构见 v0.17.36 注释块)。
import listItems from 'flarum/common/helpers/listItems';
import CardTemplatesTab from './CardTemplatesTab';
// v0.18.45 (辉哥 10/21 拍板) — 「仪表盘」tab (排课中心的默认落点)
import DashboardTab from './DashboardTab';
import StudentsListTab from './StudentsListTab';
import StatsTab from './StatsTab';
import CalendarTab from './CalendarTab';
import LessonsTab from './LessonsTab';
import SalesTab from './SalesTab';
// v0.17.80 (辉哥 10/17 拍板) — 「我的卡片」tab (权限位 scheduler.viewMyCards, 只勾学员组)
import MyCardsTab from './MyCardsTab';
import RoomsTab from './RoomsTab';
import SchoolsTab from './SchoolsTab';
import OperationLogsTab from './OperationLogsTab';
// v0.18.80 (辉哥 10/24 拍板) — 「退费管理」tab (权限位 scheduler.viewRefunds, 只读位)
import RefundMgmtTab from './RefundMgmtTab';
import UnconfiguredPage from './UnconfiguredPage';
// v0.18.18 (辉哥 10/19 拍板) — 需求一 · 未登录 (A 态) / 无权限 (B 态) 提示页
import SchedulerGatePage from './SchedulerGatePage';
// v0.17.61 — 「没配课表 → 去「校区」tab 配置」的事件名 (文案/出口与约课弹窗共用, 见该文件)
import { GO_SCHOOLS_EVENT } from '../utils/ScheduleMissingNotice';

// v0.6.53 (辉哥 9/30 16:37+ 拍板) — 每个 tab 需要的 permission method
//   Flarum 2.0 UserSerializer 暴露 (extend.php ApiResource(UserResource::class) → UserSchedulerPermissions.php)
//   前端 app.store.models.users.prototype.canView = Model.attribute('canView')
//   getter 调用返 boolean
//
// ─────────────────────────────────────────────────────────────────────────────
// v0.18.83 — 「点左上角返回图标回到上一个 tab」的两个模块级常量
//
// ① BOOT_PATH — **文档首次落点**的 pathname。
//    bundle 在页面加载时求值 ⇒ 这一刻 window.location.pathname = 文档最初载入的路径;
//    之后无论 SPA 内怎么切 route 它都不会变 ⇒ 可用来区分
//      · 「直接改地址栏进 /scheduler/sales」  ⇒ BOOT_PATH === 当前路径
//      · 「从论坛首页点链接进来的」            ⇒ 两者不等
//
// ② _isFirstSchedulerInit — 「本文档生命周期内**第一次** SchedulerIndexPage.oninit」的标记。
//    ⛔ 必须是**模块级**而不是实例级: 组件实例会被 m.route.set 重建
//    (core 的 app.history.back() 走的就是 m.route.set), 每次重建都再跑一遍 oninit ——
//    用实例级标记的话, 第二次 oninit 又会被当成「首次落点」⇒ 往栈里重复塞基线条目。
//    ⛔ 同理, 「补基线条目」这件事一辈子只做一次 (见 oninit 里的用法)。
const BOOT_PATH = window.location.pathname;
let _isFirstSchedulerInit = true;

// v0.17.27 (安全修复) — 从 normalView() 里提到模块作用域
//   原因: 权限判定现在有**两处**消费它 (tab 栏过滤 + 内容区 gate), 提成模块级常量
//   保证两处永远同源; 留在 normalView() 内部的话内容区 gate 拿不到它。
//   与后端 `SchedulerIndexController::TAB_PERMISSIONS` 一一对应
//   (值 = UserSchedulerPermissions 暴露的 canXxx; 后端同名 permission 去掉 can 前缀即 scheduler.viewStats 等)。
const TAB_PERMISSIONS = {
  // v0.18.45 (辉哥 10/21 拍板) — 「仪表盘」tab 放在**第一位**。
  //   ⚠️ 位置必须与后端 `SchedulerIndexController::TAB_PERMISSIONS` **逐字同序** (本仓硬约定)。
  //   ⚠️ 权限位是**新增**的 `canViewDashboard`, 不复用任何已有位 ——
  //      复用 canViewStats 会让「教练没有 viewStats ⇒ 连仪表盘都进不去」,
  //      而教练恰恰是仪表盘的主要用户之一 (教练看课时数, 不看金额)。
  dashboard: 'canViewDashboard',
  cards: 'canManageCards',
  students: 'canManageStudents',
  stats: 'canViewStats',
  calendar: 'canViewLessons',
  lessons: 'canViewLessons',
  sales: 'canViewStats',
  // v0.17.80 (辉哥 10/17 拍板) — 「我的卡片」tab。
  //   ⚠️ 位置插在 sales 与 rooms 之间, 与后端 `SchedulerIndexController::TAB_PERMISSIONS` 逐字同序。
  //   ⚠️ 名字对应规则: 属性名去掉 `can` 前缀 = `viewMyCards` → `scheduler.viewMyCards`。
  mycards: 'canViewMyCards',
  // v0.6.56 — logs 有专门权限 (canViewNotifications 随自建通知中心下线, 见 v0.17.32)
  rooms: 'canManageRooms',
  // v0.18.32 (辉哥 10/20 拍板) — 「校区」tab 拆成独立的 canManageSchools。
  //   ⚠️ rooms 项**不动** (仍是 canManageRooms) —— 教室能力归它, 校区能力归 manageSchools。
  //   ⚠️ 顺序与后端 `SchedulerIndexController::TAB_PERMISSIONS` 逐字同序 (schools 紧挨 rooms)。
  // v0.18.45 (辉哥 10/21 拍板) — 「校区」tab 的门换成**只读**位 `canViewSchools`。
  //   辉哥拍板: 店长**只读** (「店长只能看到自己被分配的校区」), 建/改/删校区是全站级操作。
  //   ⚠️ 「写位蕴含读位」由**后端迁移**保证 (持有 manageSchools 的组也发 viewSchools) ——
  //      前端这里**只认一个位**, 与后端 TAB_PERMISSIONS 的单值映射一一对应,
  //      不在这里写第二个事实来源。
  //   ⚠️ 名字对应规则: 属性名去掉 `can` 前缀 = `viewSchools` → `scheduler.viewSchools`。
  schools: 'canViewSchools',
  logs: 'canViewLogs',
  // v0.18.80 (辉哥 10/24 拍板) — 「退费管理」tab 的门 = 独立的**只读**位 `canViewRefunds`。
  //   ⚠️ **放最后** —— 顺序必须与后端 `SchedulerIndexController::TAB_PERMISSIONS` **逐字同序**
  //      (本仓硬约定; 后端那份已在 v0.18.79 批 A 落地, 它把 'refunds' 放在 'logs' 之后)。
  //   ⚠️ **不复用** `canViewLogs`: 操作日志只显示描述文案, 而退费记录**直接显示金额**
  //      (实退额 / 系统核算额 / 差额) ⇒ 可见面窄得多。
  //   ⚠️ 名字对应规则: 属性名去掉 `can` 前缀 = `viewRefunds` → `scheduler.viewRefunds`。
  refunds: 'canViewRefunds'
};

/**
 * v0.17.27 (安全修复) — tab 权限判定, **fail-closed 三态**
 *
 * ## 改之前是三处 fail-open
 *   ```js
 *   if (!user) return true;                        // ① 用户对象没加载 → 全部显示
 *   if (typeof permFn !== 'function') return true; // ② getter 不存在 → 全部显示
 *   try { ... } catch (e) { return true; }         // ③ getter 抛异常 → 全部显示
 *   ```
 *   安全相关的判定一律 fail-open 是不安全的: 任何一环出问题都退化成「全显示」。
 *
 * ## 改之后返回三态, 调用方**按态区分处理**, 不一刀切
 *   - `{known:false}`  用户对象压根还没加载完 (首次渲染竞态 / 未登录)
 *     ⇒ **不放行**, 但也**不当成「无权限」** — 由调用方渲染加载态并等 session 就绪后重绘。
 *       这是防「一刀切 fail-closed ⇒ 正常有权限用户首次加载时 tab 全消失」这条回归的关键。
 *   - `{known:true, allowed:false}`  权威的「无权限」答案 (getter 返回 false)
 *     ⇒ 隐藏该 tab + **不渲染对应内容**。
 *   - `{known:true, allowed:true}`   放行。
 *   getter 不存在 / 抛异常 ⇒ 一律判为**无权限** (fail-closed) 并 console.warn 记下原因。
 *
 * ## ⚠️ 「抛异常」有两层, 两层都必须兜住 (v0.17.27 补充修复)
 *   1. **取值** `user[attr]` —— getter 挂在**原型**上, 这一步自身就可能抛
 *      (底层数据没加载完时原型 getter 引用了未定义字段);
 *   2. **调用** `permFn.call(user)` —— 才轮到 getter 函数体执行。
 *   初版只包了第 2 层, 第 1 层的异常从 `.filter()` 冲出去会让**整个页面白屏**
 *   —— 而这段代码的全部意义恰恰是「不崩、不放行」。现在两层都在同一个 try 内。
 */
function tabPermission(tabKey) {
  const attr = TAB_PERMISSIONS[tabKey];
  if (!attr) {
    console.warn('[zs-v01727] unknown tab key, 判为无权限:', tabKey);
    return {
      known: true,
      allowed: false,
      reason: 'unknown-tab'
    };
  }

  // ① 用户对象还没加载完 —— 不是「无权限」, 是「还不知道」, 交给调用方走加载态
  const user = app.session && app.session.user;
  if (!user) {
    return {
      known: false,
      allowed: false,
      reason: 'user-not-loaded'
    };
  }

  // ②③ 取属性本身 与 调用 getter —— **两层都可能抛, 必须一起包进 try**
  //
  // ⚠️ v0.17.27 补充修复 (V 测报出, Mavis 核实): 原实现写成
  //      const permFn = user[attr];          ← try **外面**
  //      if (typeof permFn !== 'function') { … }
  //      try { permFn.call(user) } catch { … }   ← try 从这里才开始
  //    也就是**只包了「调用」, 漏了「取值」**。而 mithril 的 `Model.attribute('foo')`
  //    是把 getter 挂在**原型**上的 (`app.store.models.users.prototype.foo`),
  //    所以 `user[attr]` 这一次**取值动作自身**就可能抛 ——
  //    例如底层数据还没加载完时, 原型 getter 内部引用了未定义字段。
  //    异常从 `.filter()` 里冲出去 ⇒ **整个排课页面白屏**。
  //    讽刺的是这段代码存在的全部意义就是「不崩、不放行」, 自己却留了个崩的口子;
  //    并且 `reason: 'getter-missing'` 这个分支也因此永远命不中真正危险的那种情况
  //    (属性访问即抛时根本走不到它, 直接崩)。
  //
  //   修法: 把「取值 + typeof 判断 + 调用」整体放进同一个 try,
  //         任何异常路径都收敛成 `{known:true, allowed:false}` + console.warn,
  //         **绝不**把异常抛回渲染层。
  try {
    // ② getter 不存在 —— 属性没挂上 (例如 UserSchedulerPermissions 没注册) ⇒ 无权限
    const permFn = user[attr];
    if (typeof permFn !== 'function') {
      console.warn('[zs-v01727] permission getter 不存在, 判为无权限:', attr, '(tab=' + tabKey + ')');
      return {
        known: true,
        allowed: false,
        reason: 'getter-missing'
      };
    }

    // ③ getter 调用抛异常 (attribute not loaded 等) ⇒ 无权限
    return {
      known: true,
      allowed: Boolean(permFn.call(user)),
      reason: 'ok'
    };
  } catch (e) {
    console.warn('[zs-v01727] permission 取值/调用抛异常, 判为无权限:', attr, '(tab=' + tabKey + ')', e);
    return {
      known: true,
      allowed: false,
      reason: 'getter-threw'
    };
  }
}

/**
 * Ziven Scheduler 主页 — 9 个 tab + 顶部校区下拉 + v0.5.8 全局配置检查
 *
 * ziven-core 提供 window.zivenCore.SlideTab
 *   风格: 顶部色条 + 横向滚动 tabs
 *   ziven-event EventIndexPage.js 走同款模式
 *
 * v0.5.8 改造 (辉哥 9/25 10:26 拍板):
 *   - oninit 调 /api/ziiven/scheduler/config-check 查全局配置
 *   - 任何一个 setting 缺失 → 渲染 UnconfiguredPage 整页提示
 *     (header / nav tabs / 所有 tab 全部隐藏 — 辉哥 10:14 拍板)
 *   - 加 onAddStudent callback → 学生在 StudentsListTab 标题行最右侧加 + 按钮 (不重复加在 header)
 */
export default class SchedulerIndexPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    // v0.6.2a — 先 readTabFromURL, 再 history.push (避免 history.push 同步改 URL 到 /scheduler 导致 read 返 null)
    // v0.18.45 (辉哥 10/21 拍板) — 默认落点从 'cards' 改成 **'dashboard'**。
    //   辉哥硬要求: 「进入 /scheduler 默认显示仪表盘」。
    //   ⚠️ 为什么是 `||` 而不是三元: readTabFromURL() 返 null 的含义是「URL 里没有 tab 段」
    //      (此刻就是 /scheduler 本身), 这时**应该**用默认 tab; 它返一个**非法** tab 时
    //      也走这里 —— 非法值本就该被换成默认值。
    this.selectedTab = this.readTabFromURL() || 'dashboard';
    // v0.18.83 — 记下「本次挂载时对齐过的 URL」⇒ view() 里只在 URL **真的变了**时才重同步 tab
    //   (见 view() 里的说明: 无条件重同步会跟 normalView() 的权限 fallback 撞出无限重挂)
    this._syncedUrl = window.location.pathname + window.location.search;
    // v0.18.83 (改 2) — 栈里要记**当前 tab**, 而不是笼统的 'scheduler'。
    //
    //   背景 (实测): Flarum core 的 `ForumApplication.mount()` 每次启动都会往栈**底**压一条
    //   默认路由 (本站 defaultRoute = 'tags' ⇒ 栈底是 {name:'tags', url:'/'}),
    //   它的设计意图是「用户永远能点返回回首页」。所以栈里**从来不是只有一条**,
    //   `canGoBack()` 恒为 true ⇒ 左上角的返回按钮恒在。
    //   ⇒ 点它时 core 的 `history.back()` 弹掉的是**栈顶**那条 ⇒ 栈顶记的是哪个 tab,
    //      返回就回到哪个 tab。这就是本批要修的东西。
    //
    //   ⚠️ 下面两条 push 的**顺序**有意义:
    //     ① (可选) '/scheduler' 基线条目 —— 只在「文档首次落点就带 tab 段」时补 (见下)
    //     ② 当前 tab 那一条
    const urlTab = this.readTabFromURL();
    const curUrl = window.location.pathname + window.location.search;

    // v0.18.83 — 「直接改地址栏进 /scheduler/sales」时补一条 '/scheduler' 基线条目
    //   ⇒ 点返回图标回到 **/scheduler** (仪表盘), 而不是无缘无故回论坛首页。
    //   ⚠️ 只在**第一次** oninit 补 (模块级标记 _isFirstSchedulerInit):
    //      组件实例会被 m.route.set 重建 (core 的 history.back() 就走 m.route.set),
    //      每次重建都补一条 ⇒ 栈里会多出重复的 '/scheduler', 把真正的 tab 序列挤掉。
    //   ⚠️ 只在「本次就是文档的首次落点」时补: 从论坛首页点链接进来的话,
    //      上一个真实来路就是论坛首页 ⇒ 不该被 '/scheduler' 顶掉。
    if (_isFirstSchedulerInit) {
      _isFirstSchedulerInit = false;
      if (BOOT_PATH === window.location.pathname && urlTab) {
        app.history.push('scheduler', this._tabDisplayName('dashboard'), '/scheduler');
      }
    }
    this._pushHistoryEntry(this.selectedTab, curUrl, !!urlTab);
    // v0.6.21 — 首屏水平滚动自动定位 (刷新 page / 直链 deep link 都能让 active tab 居中可见)
    this._scrollActiveTabIntoView();
    this.activeSchoolId = localStorage.getItem('ziven_scheduler_active_school_id');
    this.schools = [];

    // v0.5.8 — 全局配置检查
    this.configChecked = false;
    this.unconfigured = false;
    this.configs = null;

    // v0.18.18 — gate 拦下的人**不打**这两个 API。
    //   `/ziiven/scheduler/schools` 与 `/config-check` 对访客/无权用户必然 403,
    //   打了只会在 console 里刷两条红色报错, 而这页本来就渲染不出用得上它们的内容。
    //   (被 gate 拦住时 `unconfigured` 保持 false ⇒ view() 不会误走 UnconfiguredPage。)
    this._dataLoadingStarted = false;
    if (!this.gateBlocked()) {
      this._startDataLoads();
    }

    // v0.5.9 — 监听浏览器前进/后退 (popstate) 让 tab 跟 URL 同步
    this.popStateHandler = () => {
      // v0.18.45 — 默认落点同步改成 'dashboard' (与 oninit 一致)。
      const urlTab = this.readTabFromURL();
      const newTab = urlTab || 'dashboard';
      // v0.18.83 (改 4) — 浏览器前进/后退时, 把当前 tab 记进 Flarum 的栈,
      //   这样「点返回图标」的目标始终是「上一个 tab」, 而不是别的。
      //   ⚠️ `History.push` 的「同名覆盖 top」语义正好覆盖「栈顶已经是这个 tab」的情况
      //      ⇒ 不会无脑堆栈; 它另一条「secondTop 同名 ⇒ pop」的分支
      //      正好覆盖「用户按了浏览器后退」的情况 (实测: 栈顶那条会被弹掉, 栈顶回到上一个 tab)。
      //   ⚠️ 只在**还停在 scheduler 路由**时才记: 浏览器后退**离开**本模块时
      //      (路径已经变成 '/'), 别往栈里塞一条 url='/' 的垃圾条目。
      //   ⛔ 不许在 popstate 里用 m.route.set (同样会重建组件 ⇒ 9/29 的抖动回来)
      if (window.location.pathname === '/scheduler' || urlTab) {
        this._pushHistoryEntry(newTab, window.location.pathname + window.location.search, !!urlTab);
      }
      if (newTab !== this.selectedTab) {
        this.selectedTab = newTab;
        m.redraw();
        // v0.6.21 — popstate 还原 selectedTab 后, 同步滚到 active tab
        this._scrollActiveTabIntoView();
      }
    };
    // v0.17.61 — 「没配课表 → 去「校区」tab 配置」的出口。见 oncreate 里的 addEventListener。
    //   刻意**复用既有的 selectTab()**: 它已经处理了 URL 改写 (v0.6.32 防 CLS 抖动
    //   那套原生 pushState)、redraw 和水平滚动定位。这里不重复实现一份「切 tab」的逻辑 ——
    //   两份实现迟早会只有一份跟着改。
    this.goSchoolsHandler = () => {
      this.selectTab('schools');
    };
    window.addEventListener('popstate', this.popStateHandler);
    // v0.17.61 — 「去配置课表」的跳转出口监听。约课弹窗是 app.modal.show 起的全局浮层,
    //   拿不到本组件实例; 日历那块虽是本组件的子组件, 但让它俩共用一个出口最省事,
    //   也保证两边跳过去的行为**完全一致**。详见 utils/ScheduleMissingNotice.js 顶部注释。
    //   绑定成箭头函数存在实例上, onremove 里要用**同一个引用**才能摘干净。
    window.addEventListener(GO_SCHOOLS_EVENT, this.goSchoolsHandler);
  }
  onremove(vnode) {
    super.onremove(vnode);
    // v0.17.61 — 与 oninit 成对摘掉 (漏了会在每次离开 /scheduler/* 后多留一个监听器)
    if (this.goSchoolsHandler) {
      window.removeEventListener(GO_SCHOOLS_EVENT, this.goSchoolsHandler);
      this.goSchoolsHandler = null;
    }
    // v0.5.9 — 清理 popstate 监听器, 避免内存泄漏
    if (this.popStateHandler) {
      window.removeEventListener('popstate', this.popStateHandler);
      this.popStateHandler = null;
    }
    // v0.17.27 — 清理 session 重绘轮询定时器 (有界轮询也不能漏在组件外面)
    if (this._sessionRetryTimer) {
      clearTimeout(this._sessionRetryTimer);
      this._sessionRetryTimer = null;
    }
    this._sessionRetryLeft = 0;
  }

  // v0.6.2a — 兜底: mithril 2.x route 切换但 component class 相同 (SchedulerIndexPage 用于 11 个 route) 会复用 instance, 不调 oninit
  // view() 在每次 mithril 渲染时跑 (包括 URL 变化触发的重渲染), 这里重新读 URL 设 selectedTab
  // 注意: readTabFromURL 返 null 时不能 fallback 到某个具体 tab (默认 'dashboard' 由 oninit 决定),
  // 因为 app.history.push 可能改了 URL 让 pathname 是 /scheduler —— 这时应当**用 selectedTab 自身保持**
  // (但首次 mount selectedTab 来自 oninit, 已经正确读 URL)
  // ⚠️ v0.18.45: 默认值从 'cards' 换成了 'dashboard' (辉哥硬要求), 但**这段兜底逻辑一个字没动** ——
  //    它守的是「URL 里没有 tab 段时不要乱改 selectedTab」, 与默认值无关。
  //
  // 🔴 v0.18.83 — **这段兜底逻辑原本是死代码, 已挪进本类真正的 view()** (文件末尾那个)。
  //   原因: 本类**有两个** `view()` 方法 ——
  //     · v0.6.2a 这个 `view(vnode)` (定义在前面)
  //     · v0.18.18 的 gate 分流 `view()` (定义在**后面**)
  //   JS 类里**后定义的同名方法覆盖先定义的** ⇒ 真正生效的永远是后面那个,
  //   前面这段 URL→tab 同步**从来没跑过**。
  //   ⇒ 症状: core 的 `app.history.back()` 走 `m.route.set(url)`; 当目标 URL **恰好等于
  //     mithril 眼中的当前 route** (切 tab 用的是原生 pushState, mithril 的 route 状态没跟着走)
  //     时, mithril 不会重建组件 ⇒ oninit 不会跑 ⇒ URL 已经变了但 **tab 条还是旧的**。
  //   现在这段逻辑挪进真正的 view() ⇒ 任何一次重绘都会把 tab 对齐到 URL。

  // v0.5.9 — 从 URL pathname 推断 selectedTab
  // URL: /scheduler            → 'dashboard' (默认, v0.18.45 起)
  // URL: /scheduler/dashboard  → 'dashboard'
  // URL: /scheduler/card       → 'cards'
  // URL: /scheduler/students   → 'students'
  // ... 等等
  // v0.6.2a — 加 'logs' (辉哥 9/25 12:30 报: /scheduler/logs 显示学员卡片 + 刷新报错, 根因 validTabs 漏 logs)
  // v0.18.45 — 加 'dashboard' (漏了它的症状: 直链 /scheduler/dashboard 进不去,
  //   表现成「URL 里的 tab 不被识别」⇒ selectedTab 回落默认 tab, 内容区显示的不是仪表盘)
  // v0.18.80 — 加 'refunds' (同款症状: 直链 /scheduler/refunds 会被回落成默认 tab;
  //   ⚠️ 这张表**不是** `SCHEDULER_TABS` (那是「注册路由」用的), 两处都漏 ⇒ tab 打不开)
  readTabFromURL() {
    const validTabs = ['dashboard', 'cards', 'students', 'stats', 'calendar', 'lessons', 'sales', 'mycards', 'rooms', 'schools', 'logs', 'refunds'];
    const path = window.location.pathname;
    // 提取 /scheduler/<tab> 的 tab 段
    const match = path.match(/^\/scheduler\/([a-z]+)$/);
    if (match) {
      // URL 用 'card' (单数), 内部 selectedTab 用 'cards' (复数)
      const urlTab = match[1];
      return validTabs.includes(urlTab) ? urlTab : null;
    }
    return null; // /scheduler 没 tab, 默认 'dashboard' 由 caller 处理
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    const titleText = app.translator.trans('ziven-scheduler.forum.title');
    app.setTitle(titleText);
  }

  // v0.5.8 — 检查 scheduler 全局配置 (3 个 role group mapping)
  async checkConfig() {
    try {
      const r = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/ziiven/scheduler/config-check'
      });
      this.configChecked = true;
      this.unconfigured = !(r && r.all_ok);
      this.configs = r;
      m.redraw();
    } catch (e) {
      // 配置检查接口失败 → 保守起见, 标记 unconfigured 触发整页提示 (让用户/管理员知道有问题)
      console.error('[ziven-scheduler] config-check failed', e);
      this.configChecked = true;
      this.unconfigured = true;
      this.configs = {
        all_ok: false,
        configs: [],
        missing: []
      };
      m.redraw();
    }
  }
  async loadSchools() {
    try {
      const r = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/ziiven/scheduler/schools'
      });
      this.schools = r || [];
      if (this.activeSchoolId == null && this.schools[0]) {
        this.activeSchoolId = String(this.schools[0].id);
        localStorage.setItem('ziven_scheduler_active_school_id', this.activeSchoolId);
      }
      m.redraw();
    } catch (e) {
      console.error('[ziven-scheduler] loadSchools failed', e);
    }
  }
  setSchool(schoolId) {
    this.activeSchoolId = schoolId ? String(schoolId) : null;
    if (schoolId) localStorage.setItem('ziven_scheduler_active_school_id', this.activeSchoolId);else localStorage.removeItem('ziven_scheduler_active_school_id');
    this.selectedTab = this.selectedTab;
    this.tabInstanceKey = Date.now();
    m.redraw();
  }

  /**
   * v0.18.83 — tab 的**显示名** (给 Flarum history 条目当 title 用)
   *
   * ⚠️ 刻意复用 buildTabList() ⇒ **不新造一套翻译 key**,
   *    改 tab 名时这里自动跟上 (brief 改 1 ③ 的硬要求)。
   *    取不到 (tab key 不在清单里) ⇒ 回落成 key 本身, 不抛异常。
   */
  _tabDisplayName(key) {
    const t = this.buildTabList().find(x => x.key === key);
    return t ? t.name : key;
  }

  /**
   * v0.18.83 — 把「当前 tab」记进 **Flarum 自己的 history 栈** (app.history)
   *
   * @param {string}  tabKey        tab 的 key
   * @param {string}  url           这一条对应的 URL (绝对路径, 带 query)
   * @param {boolean} hasTabSegment URL 里有没有 tab 段
   *        · 有 ⇒ name = 'scheduler.<key>'  (与 extend.php 的 route name 逐字一致)
   *        · 无 ⇒ name = 'scheduler'        (与 extend.php 的 '/scheduler' route name 一致)
   *
   * ⚠️ `app.history.push()` **只动 Flarum 自己的栈**, 不触发 mithril router
   *    ⇒ 组件不会被重建 ⇒ .ZS-tabrow 里的 Dropdown 子树保持 stable (见 selectTab 的 v0.6.32 踩坑史)。
   */
  _pushHistoryEntry(tabKey, url, hasTabSegment) {
    const name = hasTabSegment ? 'scheduler.' + tabKey : 'scheduler';
    app.history.push(name, this._tabDisplayName(tabKey), url);
  }
  selectTab(key) {
    // v0.18.83 (改 1 ①) — 点**同一个** tab ⇒ 直接返回。
    //   ⛔ 不许再往下走: 再 push 一次会在**浏览器原生历史**里多压一条 entry
    //      ⇒ 浏览器返回要点好几次才回得去 (验收 2 的第 2 条就是这条)。
    //   ⚠️ 注意: `app.history.push` 本身是「同名覆盖 top」语义, 不会把 Flarum 的栈堆深;
    //      真正会堆深的是下面第 ④ 步的**原生** pushState ⇒ 这道闸必须留。
    if (key === this.selectedTab) return;
    this.selectedTab = key;
    const newPath = '/scheduler/' + key;

    // v0.18.83 (改 1 ③) — 让 Flarum 的栈知道这个 tab。
    //   core 的 `history.back()` 弹掉的是**栈顶**那条 ⇒ 栈顶记的是哪个 tab,
    //   点左上角返回图标就回到哪个 tab (这正是辉哥 10/24 23:0x 反馈的那件事)。
    this._pushHistoryEntry(key, newPath, true);

    // v0.6.32 — 用 history.pushState 而非 m.route.set (修切 tab 时 dropdown DOM 被替换 + CLS 0.0984)
    //   真 root cause: m.route.set 触发 mithril router 重新解析路由, 即使 component class 相同
    //   也会**新建 SchedulerIndexPage 实例** (onremove → oninit → oncreate 全跑, V 测 hook 实证)
    //   → .ZS-tabrow 里的整个 Dropdown 子树 (含 ButtonGroup + toggle button) 被 unmount/remount
    //   → dropdown toggle 按钮 DOM 被替换 (16ms 视觉空白 + paint flash)
    //   → 学生卡片/icon/AlertManager 周围元素 layout shift (CLS 累计 0.0984)
    //   → 辉哥 9/29 19:42 反馈"切换 tab 时顶部 dropdown 感觉内容有变动"
    //   history.pushState 只改 URL 不触发 mithril router, 复用当前 instance, dropdown 子树 stable
    //   ⛔ 绝对不许改回 m.route.set / app.route.set (9/29 的抖动就来自它)
    //
    // v0.18.83 — replaceState → **pushState**:
    //   切 tab 现在要**建**一条历史 entry, 否则浏览器前进/后退走不到 tab 之间
    //   (验收 3 / 验收 4)。仍然只用原生 API ⇒ 不触发 mithril router ⇒ 组件不重建。
    if (window.location.pathname !== newPath) {
      window.history.pushState(window.history.state, '', newPath);
    }
    m.redraw();
    // v0.6.21 — 用户点击 tab 时也水平滚动到 active tab (跟 v0.6.20 ziven-core SlideTab selectItem 行为对齐)
    this._scrollActiveTabIntoView();
  }

  /**
   * v0.18.69 — 「查看学员」: 跳到**学员列表** tab, URL 带 `?highlight_student={id}`
   *
   * ⚠️ **不复用 selectTab()**: 它把 URL 写成 `/scheduler/students` (⛔ 把 query 丢了)
   *   ⇒ 学员列表读不到高亮参数。这里自己写 URL, 保留 query。
   *   ⚠️ query 挂在 URL 上**不影响**路由解析 (readTabFromURL 只看 pathname),
   *      所以 F5 / 直接分享这条链接也能落到学员列表 tab。
   *
   * v0.18.83 (改 3) — 它同样是一次「切 tab」(销售跟进 → 学员列表),
   *   ⇒ 同样要: ① 让 Flarum 的栈知道 (否则点返回图标还是回论坛首页)
   *             ② 用**原生** pushState 改 URL (⛔ 禁用 m.route.set, 同 selectTab 的 v0.6.32 踩坑史)
   */
  viewStudent(studentId) {
    const id = Number(studentId);
    if (!id) return;
    this.selectedTab = 'students';
    const newPath = '/scheduler/students?highlight_student=' + id;
    this._pushHistoryEntry('students', newPath, true);
    if (window.location.pathname + window.location.search !== newPath) {
      window.history.pushState(window.history.state, '', newPath);
    }
    m.redraw();
    // v0.6.21 — 与 selectTab 同款: 水平滚动让 active tab 完全可见
    this._scrollActiveTabIntoView();
  }

  // v0.6.21 — 水平滚动 .ZS-slide-tab-bar, 让 active tab **完全可见**
  // 不放在 view() 里, view() 每次 mithril 渲染都跑, 会破坏用户手动滚动体验
  // 只在 selectedTab 真正变化时 (oninit 首屏 / popstate / selectTab 点击) 触发
  //
  // ──────────── 踩坑史 (改这块前先读完, 别把治好的抖动放回来) ────────────
  //
  // v0.7.9c (辉哥 10/5 反馈「切换 tab 时不居中」) — 当时把滚动目标算成「tab 中心对齐
  //   bar 中心」。但首/尾 tab 物理上滚不到中心: 要 scrollLeft 为负 / 超界, 浏览器
  //   只能夹到 0 或 maxScroll。于是加了 _syncTabLead() 算一个 --zs-tab-lead,
  //   由 less/forum.less 的 ::before/::after 伪元素渲染成**两端留白**,
  //   把首/尾 tab 往内推到能滚到中心的位置。
  //   实测 (390 屏, tab 约 122px): ideal = 390/2 - 122/2 = 134,
  //   lead = min(134, maxScroll + 61) = 134 ⇒ 两端各 134px 空白, 占屏宽 34%。
  //
  // v0.17.35 (辉哥 10/14 反馈「选第一个 tab 左边留一大片空白, 选最后一个右边也是」)
  //   — 方案 A, 改回 iOS 标签栏 / 微信 / Chrome 的标准行为「只在看不见时才滚动」:
  //     首项左对齐、末项右对齐, 只有看不见时才滚, 中间看不见的 tab 滚到**刚好完全可见**
  //     (不是居中)。大白留白看着像出了 bug, 首尾 tab 贴边才是标准行为。
  //   ⇒ 删掉 --zs-tab-lead + 伪元素 + _syncTabLead() 整个方法 (留白机制整体退场),
  //     padding: 12px 32px 0 32px / scroll-padding: 0 32px **保留** ——
  //     它们是 v0.5.0b~k 起的首尾 tab 视觉内边距, 跟留白机制无关 (v0.7.9c 之前就在),
  //     也是下面「可见区内缩」的依据。
  //
  // ⚠️ v0.7.9c 踩过、这版原样保留的坑:
  //   ① 双 rAF 结构不许合并成一层: m.redraw() 是 **rAF 批处理**, 同帧内
  //      querySelector('.ZS-slide-tab.active') 拿到的还是**上一个** tab 的元素
  //      (实测每次切 tab 少滚一个 tab 宽度 = 122px, 永远差一格)。删掉会直接
  //      重现「每次切 tab 少滚一个 tab 距离」的 bug。
  //   ② expectedKey 校验不许删: 动画未完成时又切 tab → 本次滚动作废, 交给新一轮。
  //   ⚠️ CSS 侧同理别动: scroll-snap-type: x proximity (v0.6.22c 从 mandatory 改来,
  //      mandatory 会跟 jQuery animate 双触发抖动) + tabindex="-1" + onclick
  //      e.preventDefault() (v0.6.22d/e, 挡 click/tap 的浏览器内置 scrollIntoView)。
  _scrollActiveTabIntoView() {
    const expectedKey = this.selectedTab;
    const raf = window.requestAnimationFrame || function (fn) {
      return setTimeout(fn, 16);
    };
    // 第 1 帧: 让出执行权给 mithril 的 redraw rAF
    raf(() => {
      // 第 2 帧: DOM 已反映新的 active tab (① 理由见上, 这层 rAF 不能省)
      raf(() => {
        // ② 期间用户又切了 tab → 本次滚动作废, 交给新一轮调用
        if (this.selectedTab !== expectedKey) return;
        const activeTab = document.querySelector('.ZS-slide-tab.active');
        if (!activeTab) return;
        // v0.6.22b: jQuery animate 180ms (辉哥 9/28 19:33 拍板方案 A) — 有滑动感, 时长不许改
        if (typeof $ === 'undefined') return; // jQuery 还没加载, 静默 no-op (刷新场景)
        const $bar = $('.ZS-slide-tab-bar');
        const bar = $bar[0];
        if (!bar) return;
        const barRect = bar.getBoundingClientRect();
        const tabRect = activeTab.getBoundingClientRect();
        // 可见区按左右 padding 内缩: tab 滚到「刚好完全可见」算到位, 不去贴屏幕硬边缘。
        // ⚠️ 数值现状: v0.17.36 的 .ZS-tabrow > .ZS-slide-tab-bar 把 bar 的 padding 设成了 0
        //   (内边距改由 .ZS-tabrow 提供, scroll-padding 同样归 0), 所以现在 padL / padR
        //   实测读出来就是 0 —— tab 是贴着 bar 边缘算的, 不是贴着 32px 内边距。
        //   上方 v0.17.35 那段记的是「贴着 32px」, 那是当时 bar 仍有 12px 32px 0 32px 时的状态。
        // 设计意图 (v0.17.35 有意为之, 别改): padding 从 computed style 动态读, 不写死 ——
        //   以后若恢复 bar 自己的 padding, 这里自动跟上, 无需再改 JS。
        const cs = window.getComputedStyle(bar);
        const padL = parseFloat(cs.paddingLeft) || 0;
        const padR = parseFloat(cs.paddingRight) || 0;
        const viewW = bar.clientWidth;
        const cur = bar.scrollLeft;
        // tab 在 scroll 内容里的绝对偏移 (scroll 坐标)。
        // 不再减 --zs-tab-lead —— 留白机制整个删了 (v0.7.9c 当年那个「每个 tab 恰好多偏
        // 一个 lead = 121px」的二次踩坑, 根因就是多减了一次 lead)。
        const tabLeft = tabRect.left - barRect.left + cur;
        const tabRight = tabLeft + tabRect.width;
        const viewLeft = cur + padL;
        const viewRight = cur + viewW - padR;
        // 只滚「刚好够」的量: 已经完整可见 → delta = 0, 一个像素都不滚。
        // 首项在 scrollLeft=0 本就完整可见 → 不滚 (左边零空白);
        // 末项在 maxScroll 本就完整可见 → 不滚 (右边零空白)。
        let delta = 0;
        if (tabRight > viewRight) delta = tabRight - viewRight; // 右边被切 → 往右滚
        else if (tabLeft < viewLeft) delta = tabLeft - viewLeft; // 左边被切 → 往左滚
        if (!delta) {
          // delta=0 也要 stop(): 上一次点击的动画可能还在飞, 让它继续飞到过时位置
          // 会把 active tab 滚出视野 (明明可见却被滚走)。stop() 停在当前值 = 不动。
          $bar.stop();
          return;
        }
        // clamp 到 [0, maxScroll] —— 浏览器本来也会夹, 这里夹是为了 target===cur 时
        // 不启动一个纯 no-op 的动画计时器
        const maxScroll = Math.max(0, bar.scrollWidth - viewW);
        const target = Math.max(0, Math.min(maxScroll, cur + delta));
        if (target === cur) {
          $bar.stop();
          return;
        }
        $bar.stop().animate({
          scrollLeft: target
        }, 180);
      });
    });
  }

  // v0.7.9c 的 _syncTabLead() (两端留白宽度计算) 已在 v0.17.35 **整个方法删除**。
  // 留白宽度 = min(半个可视区 - 半个 tab 宽, maxScroll + 半个 tab 宽), 由 JS 写入
  // --zs-tab-lead 驱动 less/forum.less 的 ::before/::after。删除原因见上方踩坑史:
  //   为「active tab 永远居中」而留的两端空白, 在 390 屏上各占 134px (屏宽 34%),
  //   辉哥 10/14 判定大片空白更像出了 bug。改「只在看不见时才滚动」后不再需要留白,
  //   少一层 rAF 也少一个样式回写 (旧实现 setProperty 后同帧量 rect 会读到旧值,
  //   是 v0.7.9c 的二次踩坑)。⚠️ 不要「顺手恢复」这个方法。

  // v0.5.8 — 顶部 header + 按钮 (学生列表 tab 用, 来自 AddStudentModal)
  // v0.19.30 — 「添加学员」改两步流程: onClose 现在是「第 2 步(绑定卡片)成功后」的回调;
  //   同时把「刷新列表」的回调 (onDone) 一起透传进来。
  openAddStudent(onDone) {
    app.modal.show(require('./../modal/AddStudentModal').default, {
      activeSchoolId: this.activeSchoolId,
      schools: this.schools,
      // ⛔ 原来只有 m.redraw() ⇒ StudentsListTab.load() 不会重跑 (它只在 oninit / 切校区时跑)
      //    ⇒ 添加完学员列表不刷新。现在把 onDone 透传下去, 由列表自己 load()。
      onClose: () => {
        m.redraw();
        if (onDone) onDone();
      }
    });
  }

  /**
   * v0.18.18 — **未按权限过滤**的完整 10 tab 清单 (名字 / 图标 / 颜色 / key)。
   *
   * ## 为什么要抽出来
   *   v0.18.18 之前这段数组是 `normalView()` 里内联的字面量。现在有三处消费它:
   *     ① `normalView()`  — 按 `tabPermission()` 过滤后渲染正常 tab 条
   *     ② `gateView()`    — 提示页要渲染**完整** tab 条 (设计稿: 置灰, 证明「这不是 404」)
   *     ③ `SchedulerGatePage` 的功能矩阵 — 直接拿 `t.name` 当**中文功能名**
   *   写三遍的话, 改一个 tab 名就会漏一处 —— 而 ③ 那处漏了等于给用户看错功能名。
   *
   * ⚠️ 顺序 / 图标 / 颜色一律照搬原字面量, 本轮**零改动**。
   *   ⚠️ `mycards` 那段「tab 栏拥挤问题按辉哥拍板 A 方案 = 什么都不改」的注释保留,
   *      移到这里了 —— 见下方 `mycards` 项。
   */
  buildTabList() {
    return [
    // v0.18.45 (辉哥 10/21 拍板) — 「仪表盘」tab 排**第一位**。
    //   ⚠️ 顺序必须与后端 TAB_PERMISSIONS 逐字同序。
    //   ⚠️ 图标用 FA6 solid 的 fa-gauge-high (仪表盘语义最贴), 颜色用靛蓝 #6366f1 ——
    //      与已有的 11 个 tab 颜色**都不同**, 视觉上能一眼认出「这是首页」。
    {
      name: app.translator.trans('ziven-scheduler.forum.tab-dashboard'),
      key: 'dashboard',
      icon: 'fa-gauge-high',
      color: 'var(--zs-indigo-6366f1, #6366f1)'
    }, {
      name: app.translator.trans('ziven-scheduler.forum.tab-cards'),
      key: 'cards',
      icon: 'fa-id-card',
      color: 'var(--zs-info-60a5fa, #60a5fa)'
    }, {
      name: app.translator.trans('ziven-scheduler.forum.tab-students'),
      key: 'students',
      icon: 'fa-users',
      color: 'var(--zs-purple-a78bfa, #a78bfa)'
    }, {
      name: app.translator.trans('ziven-scheduler.forum.tab-stats'),
      key: 'stats',
      icon: 'fa-chart-simple',
      color: 'var(--zs-success-34d399, #34d399)'
    }, {
      name: app.translator.trans('ziven-scheduler.forum.tab-calendar'),
      key: 'calendar',
      icon: 'fa-calendar-days',
      color: 'var(--zs-warning-fbbf24, #fbbf24)'
    }, {
      name: app.translator.trans('ziven-scheduler.forum.tab-lessons'),
      key: 'lessons',
      icon: 'fa-calendar-check',
      color: 'var(--zs-pink-f472b6, #f472b6)'
    }, {
      name: app.translator.trans('ziven-scheduler.forum.tab-sales'),
      key: 'sales',
      icon: 'fa-briefcase',
      color: 'var(--zs-cyan-22d3ee, #22d3ee)'
    },
    // v0.17.80 (辉哥 10/17 拍板) — 「我的卡片」tab (只勾学员组; Mod 拿不到这个位)
    //   ⚠️ tab 名用「我的卡片」, 辉哥拍板 3.3: 学员不会把它跟「约课管理」搞混,
    //      所以不加副标题、不加区分前缀。
    //   ⚠️ tab 栏拥挤问题按辉哥拍板「A 方案 = 什么都不改」处理:
    //      `.ZS-slide-tab-bar` 本来就是 overflow-x:auto, 且已有 _scrollActiveTabIntoView()
    //      (点 tab 自动滚到可见) ⇒ 功能不缺, 只是首屏看不见最右那个。
    //      **不要**为了装得下去去调 tab 内边距 / 改字体 / 收窄校区下拉 (辉哥已逐条否决)。
    {
      name: app.translator.trans('ziven-scheduler.forum.tab-mycards'),
      key: 'mycards',
      icon: 'fa-id-badge',
      color: 'var(--zs-success-34d399, #34d399)'
    }, {
      name: app.translator.trans('ziven-scheduler.forum.tab-rooms'),
      key: 'rooms',
      icon: 'fa-house',
      color: 'var(--zs-success-4ade80, #4ade80)'
    }, {
      name: app.translator.trans('ziven-scheduler.forum.tab-schools'),
      key: 'schools',
      icon: 'fa-location-dot',
      color: 'var(--zs-danger-f87171, #f87171)'
    },
    // v0.6.2 — 操作日志 tab (辉哥 9/25 12:13 拍板, 校区隔离按时间倒序展示)
    {
      name: app.translator.trans('ziven-scheduler.forum.tab-logs'),
      key: 'logs',
      icon: 'fa-scroll',
      color: 'var(--zs-text-1-cbd5e1, #cbd5e1)'
    },
    // v0.18.80 (辉哥 10/24 拍板) — 「退费管理」tab (排**最后**, 设计稿 E 项)
    //   ⚠️ 图标色用 **橙色** `--zs-orange-f97316` —— 现有 11 个 tab 里**唯一没被占用**的色族
    //      (⛔ 不要跟别的 tab 撞色)。深色 #f97316 / 浅色 #ea580c。
    //   ⚠️ 顺序必须与后端 TAB_PERMISSIONS 逐字同序。
    {
      name: app.translator.trans('ziven-scheduler.forum.tab-refunds'),
      key: 'refunds',
      icon: 'fa-file-invoice-dollar',
      color: 'var(--zs-orange-f97316, #f97316)'
    }];
  }

  // ── v0.18.18 (辉哥 10/19 拍板) — 需求一 · gate 三态 ──

  /**
   * 服务端下发的 gate 状态。
   *
   * ## 权威性
   *   来自 `$document->payload['schedulerGate']` (后端 `SchedulerIndexController` 用
   *   `$actor->can()` 算出)。**前端不能伪造也不能重算** —— payload 是服务端渲染进 HTML 的。
   *
   * ## 拿不到 payload 怎么办 (fail-open 到 `allow`, 不是 fail-closed)
   *   拿不到只有两种可能: ① 这一页根本不是 scheduler 路由 (理论上不可能, 组件只挂在
   *   `/scheduler*` 上); ② 后端 payload 被别的扩展整个覆盖掉。
   *   这两种情况下**继续走 v0.17.27 的既有 fail-closed 三态** (tabPermission) 才是对的 ——
   *   `normalView()` 第一件事就是 session 未就绪 → perm-loading, 之后 `tabPermission()`
   *   逐 tab fail-closed。也就是说: **内容门仍然在, 这里只是决定「要不要先弹提示页」。**
   *   ⚠️ 反过来刻意**不**做成 fail-closed: 万一 payload 缺失就把所有人卡在提示页,
   *      那才是真正的全站故障 —— 宁可回退到原有行为 (原有行为本身是安全的)。
   */
  gateState() {
    const gate = app.data && app.data.schedulerGate;
    if (!gate || !gate.state) return null;
    return gate;
  }

  /** 当前登录用户能不能打开这个 tab (B 态用它决定 tab 条上哪个可点 + 矩阵里哪个是解锁) */
  isTabOpen(tabKey) {
    return tabPermission(tabKey).allowed;
  }

  /**
   * 把服务端快照与**实时 session** 合并后的 gate 判定。
   *
   * @returns {object|null} `null` = 放行, 走原有正常逻辑; 否则是提示页 payload
   */
  effectiveGate() {
    const server = this.gateState();
    if (!server || server.state === 'allow') return null;

    // 逃生口**只对 `guest` 开**: 访客可能是在页面没刷新的情况下用站点顶栏的登录弹窗
    // 登录的 (设计稿页头就有那个「登录」按钮), 这时服务端快照已经过期, 以实时 session 为准。
    // ⛔ `denied` **不给逃生口**: 服务端是在用户已登录的前提下算出「这个 tab 无权」,
    //    那份快照不会因为前端发生了什么而失效, 放行它等于给 B 态开一个绕过口子。
    if (server.state === 'guest' && app.session && app.session.user) return null;
    return server;
  }
  gateBlocked() {
    return this.effectiveGate() !== null;
  }
  _startDataLoads() {
    if (this._dataLoadingStarted) return;
    this._dataLoadingStarted = true;
    this.loadSchools();
    this.checkConfig();
  }
  gateView(gate) {
    return m(SchedulerGatePage, {
      state: gate.state,
      gate: gate,
      tabs: this.buildTabList(),
      isTabOpen: key => this.isTabOpen(key),
      onSelectTab: key => this.selectTab(key)
    });
  }

  // ── 正常视图 (有配置时) ──
  normalView() {
    const _this = this;
    const SlideTab = window.zivenCore && window.zivenCore.SlideTab;

    // v0.6.22 (辉哥 9/28 18:14 + 18:20 拍板) — emoji 前缀去掉, 改 FontAwesome 6 solid 彩色图标
    //   子变体 B (无底色): icon 15px 纯彩色, active 时 brightness 1.3 提亮, 颜色由 inline style 给
    //   10 tab 10 色 (天蓝/紫罗兰/翠绿/琥珀/粉红/青蓝/橙/草绿/珊瑚红/石板灰), active underline 色走 data-k CSS 规则

    // ── v0.17.27 (安全修复) — session 没就绪: 不放行, 但也不能当「无权限」把 tab 全干掉 ──
    //   第一次渲染时 app.session.user 可能还没挂上。此时若一刀切 fail-closed,
    //   正常有权限用户的 tab 会瞬间全消失 (本次修复最大的回归风险)。
    //   做法: 走加载态 —— **一个 tab 都不渲染、tab 栏也不渲染**, 但不是「无权限」空态,
    //   并起一个有界重绘轮询, session 就绪后自动 redraw 出真tab。
    //   ⚠️ v0.18.18: 后端这一层门不再 403, 而是下发 `state` (见文件末尾 gateState()),
    //      所以访客与无权用户在 `view()` 里就被分流到 SchedulerGatePage 了,
    //      **根本走不到这里**。下面这段现在只覆盖「已放行但 session 还没就绪」这一种情况。
    if (!(app.session && app.session.user)) {
      this._scheduleSessionRetry();
      return this.hintView('perm-loading');
    }
    const tabList = this.buildTabList().filter(t => tabPermission(t.key).allowed).map(t => ({
      name: t.name,
      key: t.key,
      icon: t.icon,
      color: t.color,
      event: function () {
        _this.selectTab(t.key);
      }
    }));

    // ── v0.17.27 — 一个 tab 都没有 ⇒ 明确「无权限」空态, 且**内容区一律不渲染** ──
    //   改之前这里只有 `tabList.length > 0` 才做 fallback, tabList 为空时 selectedTab
    //   保持不变 → 内容区照常渲染 (这就是「空 tab 栏 + 照常渲染的页面内容」那个洞)。
    if (tabList.length === 0) {
      console.warn('[zs-v01727] 当前用户没有任何 scheduler tab 权限 → 渲染无权限空态, 不渲染内容');
      return this.hintView('perm-none');
    }

    // v0.6.53 — selectedTab fallback: 当前 selectedTab 没权限时 (hidden by filter), 跳到第一个有权限的 tab
    //   防止出现"当前 URL /scheduler/cards 但 tab 被 hide, body 显示空内容"
    if (!tabList.some(t => t.key === this.selectedTab)) {
      this.selectedTab = tabList[0].key;
      app.history.push('scheduler.' + tabList[0].key);
    }

    // ── v0.17.27 (第二层门) — 内容区也要 gate ──
    //   后端路由门管的是**首次进入 / 直接改地址栏**; tab 切换走客户端 app.history.push(),
    //   这一段不经过后端。所以内容区必须自己再判一次, 否则 tab 栏过滤形同虚设。
    //   注意这是**在 fallback 之后**算的: fallback 已把无权限的 selectedTab 换成有权限的那个,
    //   所以正常路径 contentAllowed 恒为 true; 它拦的是 fallback 没覆盖到的边界
    //   (tabList 非空但 getter 状态在同一次渲染里变了 / 客户端改 URL 指向越权 tab)。
    const contentAllowed = tabPermission(this.selectedTab).allowed;
    return m("div", {
      className: "ZivenSchedulerRoot"
    }, m("div", {
      className: "ZS-tabrow"
    }, m(Dropdown, {
      buttonClassName: "ZS-school-dropdown-btn",
      icon: "fas fa-house",
      label: (() => {
        const s = this.schools.find(x => String(x.id) === String(this.activeSchoolId));
        return s ? s.name : app.translator.trans('ziven-scheduler.forum.school-dropdown.select-school');
      })()
    }, this.schools.map(s => m(Button, {
      key: s.id,
      active: String(s.id) === String(this.activeSchoolId),
      onclick: () => this.setSchool(s.id)
    }, m("i", {
      className: "fas fa-building",
      style: "color:var(--zs-brand-3b82f6, #3b82f6);margin-right:6px;"
    }), s.name, m("span", {
      className: "ZS-school-dropdown-meta"
    }, ' ', s.student_count || 0, " \u5728\u8BFB\u5B66\u5458 \xB7 ", s.assigned_coach_count || 0, " \u6559\u7EC3 \xB7 ", s.room_count || 0, " \u6559\u5BA4")))), m("div", {
      className: "ZS-slide-tab-bar"
    }, tabList.map(t => m("div", {
      className: 'ZS-slide-tab ' + (this.selectedTab === t.key ? 'active' : ''),
      "data-k": t.key,
      key: t.key,
      tabindex: "-1" /* v0.6.22d — 加 tabindex="-1" 阻止 click 时浏览器 focus + scrollIntoView (辉哥 20:10 拍板方案 A)
                      *   真实 root cause: click → focus 元素 → scrollIntoView → snap 配合 → scrollLeft 0→512
                      *   mithril 重渲染 → scrollLeft 重置 0 → jQuery animate 0-512 (双触发抖动)
                      *   tabindex="-1" 让元素不参与 focus, click 不触发 scrollIntoView, mithril onclick 仍触发
                      */,
      onclick: e => {
        e.preventDefault(); /* v0.6.22e — 阻止 mobile tap 触发的内置 scroll-into-view (辉哥 20:30 反馈)
                             *   真 root cause: mobile Chrome tap-scroll-into-view (V 测控制变量实验定位)
                             *   5 轮返工 (scrollIntoView smooth → instant → jQuery 180ms → proximity → tabindex) 全失败
                             *   e.preventDefault() 阻止 native click default, mithril onclick 仍触发
                             */
        this.selectTab(t.key);
      }
    }, m("i", {
      className: 'ZS-tab-icon fas ' + t.icon,
      style: {
        color: t.color
      }
    }), m("span", {
      className: "ZS-tab-label"
    }, t.name))))), m("div", {
      className: "ZS-tab-content"
    }, contentAllowed ? m("div", {
      key: 'tab-' + this.selectedTab + '-' + (this.tabInstanceKey || 0)
    }, this.selectedTab === 'dashboard' &&
    // v0.18.45 (辉哥 10/21 拍板) — 「仪表盘」tab。
    //   activeSchoolId 传下去 = 仪表盘的校区维度与顶部校区下拉**联动**
    //   (选了校区, 仪表盘跟着切)。传 null = 跟随后端按可见校区算。
    //   ⚠️ `tabPermission` 传下去 = KPI 跳转的**唯一**权限判据
    //      (辉哥原话: 「根据权限判断一下, 如果没有权限就没有跳转链接」)。
    //      刻意**不**在 DashboardTab 里再写一份角色白名单 ——
    //      店长/教练/销售的权限组合后台可配, 硬编码本来就不准。
    //   ⚠️ `onSelectTab` = 父组件的 selectTab (与 tab 条点击同款行为)。
    // v0.18.45b — `tabs` = **tab 条自己的清单** (buildTabList())。
    //   KPI 右上角跳转角标上的中文名直接取自这里 ⇒ 角标名跟 tab 条名
    //   **永远一致**, 不另建一张映射表 (取不到时组件内部回落 translator)。
    m(DashboardTab, {
      activeSchoolId: this.activeSchoolId,
      tabPermission: tabPermission,
      onSelectTab: key => this.selectTab(key),
      tabs: this.buildTabList()
    }), this.selectedTab === 'cards' && m(CardTemplatesTab, {
      activeSchoolId: this.activeSchoolId
    }), this.selectedTab === 'students' && m(StudentsListTab, {
      activeSchoolId: this.activeSchoolId,
      schools: this.schools,
      onAddStudent: onDone => this.openAddStudent(onDone)
    }), this.selectedTab === 'stats' && m(StatsTab, {
      activeSchoolId: this.activeSchoolId
    }), this.selectedTab === 'calendar' && m(CalendarTab, {
      activeSchoolId: this.activeSchoolId
    }), this.selectedTab === 'lessons' && m(LessonsTab, {
      activeSchoolId: this.activeSchoolId
    }), this.selectedTab === 'sales' && /* v0.18.69 — schools 传下去 = 转学员弹层的校区名; onViewStudent = 「查看学员」跳转 */
    m(SalesTab, {
      activeSchoolId: this.activeSchoolId,
      schools: this.schools,
      onViewStudent: id => this.viewStudent(id)
    }), this.selectedTab === 'mycards' && m(MyCardsTab, {
      schools: this.schools
    }), this.selectedTab === 'rooms' && m(RoomsTab, {
      activeSchoolId: this.activeSchoolId,
      schools: this.schools
    }), this.selectedTab === 'schools' && m(SchoolsTab, {
      activeSchoolId: this.activeSchoolId
    }), this.selectedTab === 'logs' && m(OperationLogsTab, {
      activeSchoolId: this.activeSchoolId
    }), this.selectedTab === 'refunds' && m(RefundMgmtTab, {
      schools: this.schools
    })) : null));
  }

  // v0.17.27 — 权限态提示页 (加载态 / 无权限态共用一个壳)
  //   刻意**不渲染 tab 栏和任何 tab 内容**: 这两个态下都还没有「该用户该看到什么」的确定答案,
  //   渲染任何 tab 内容都属于越权。区别只在文案 —— 一个是「还不知道」, 一个是「确定为无」。
  hintView(transKey) {
    return m("div", {
      className: "ZivenSchedulerRoot"
    }, m("div", {
      className: "ZS-tab-content"
    }, m("div", {
      className: "ZS-perm-hint"
    }, app.translator.trans('ziven-scheduler.forum.' + transKey))));
  }

  // v0.17.27 — session 未就绪时的**有界**重绘轮询
  //   存在的唯一理由: 防「一刀切 fail-closed ⇒ 正常有权限用户首次加载时 tab 全消失」这条回归。
  //   有界 (默认 30 次 × 50ms ≈ 1.5s), 到点/就绪即停, 不留悬挂定时器;
  //   onremove 里会强制清理。超时后仍无 user → 停在 perm-loading 态, 不会误显示任何内容。
  _scheduleSessionRetry() {
    if (this._sessionRetryTimer) return;
    if (this._sessionRetryLeft === undefined) this._sessionRetryLeft = 30;
    if (this._sessionRetryLeft <= 0) return;
    this._sessionRetryLeft -= 1;
    this._sessionRetryTimer = setTimeout(() => {
      this._sessionRetryTimer = null;
      if (app.session && app.session.user) this._sessionRetryLeft = 0;
      this._scheduleSessionRetry();
      m.redraw();
    }, 50);
  }

  // ── 配置检查失败时: 整页提示, 隐藏 header / nav tabs / 所有 tab ──
  unconfiguredView() {
    // ConfigCheckController 返 configs 是 object {student: {...}, coach: {...}, sales: {...}}
    // 传给 UnconfiguredPage 要转成 array (Object.values)
    const allConfigs = this.configs && this.configs.configs ? Object.values(this.configs.configs) : [];
    const missing = this.configs && this.configs.missing || [];
    return m(UnconfiguredPage, {
      allConfigs: allConfigs,
      missing: missing
    });
  }
  view() {
    // ── v0.18.83 — URL → tab 的兜底同步 (从 v0.6.2a 那个**被覆盖掉**的 view(vnode) 挪过来) ──
    //   ⚠️ 背景: 本类**只有这一个** view() 生效 (类里同名方法后者覆盖前者,
    //      v0.6.2a 写在前面那段一直是死代码)。切 tab 用的是原生 pushState,
    //      **不通知 mithril router** ⇒ mithril 眼里的当前 route 停在「组件挂载时那条」。
    //      core 的 `app.history.back()` 走 `m.route.set(url)`: 若目标 URL 恰好等于那条,
    //      mithril 不会重建组件 ⇒ oninit 不跑 ⇒ **URL 变了但 tab 条还是旧的**。
    //   ⇒ 这里在任何一次重绘时把 tab 对齐到 URL。
    //
    //   ⚠️ 只在 **URL 真的变了**时才动 (用 _syncedUrl 记上一次对齐过的 URL):
    //      若每次重绘都改 tabInstanceKey, 「URL 指向一个当前用户**没权限**的 tab」那个分支
    //      会被 normalView() 的权限 fallback 反复改回 selectedTab ⇒ key 每次都变
    //      ⇒ 内容区反复重挂 ⇒ 无限重取 ⇒ 卡死。
    const curUrl = window.location.pathname + window.location.search;
    if (curUrl !== this._syncedUrl) {
      this._syncedUrl = curUrl;
      // ⚠️ readTabFromURL() 返 null 有两种情形, 这里**都**落到默认落点 'dashboard':
      //      ① URL 是 '/scheduler' (无 tab 段) ⇒ 它就是「排课中心首页 = 仪表盘」
      //      ② URL 的 tab 段非法 ⇒ 同样按默认落点处理 (与 oninit 一致)
      //   (v0.6.2a 当年写的是「返 null 时保持 selectedTab 自身」, 那是因为当时
      //    `app.history.push` 可能顺手把 URL 改成 '/scheduler'; 现在 URL **只有**我们自己写,
      //    且永远写成 '/scheduler/<tab>' ⇒ '/scheduler' 就是落地页, 不会有第二种解释。)
      const urlTab = this.readTabFromURL() || 'dashboard';
      if (urlTab !== this.selectedTab) {
        this.selectedTab = urlTab;
      }
      this.tabInstanceKey = Date.now();
    }

    // ── v0.18.18 (辉哥 10/19 拍板) — gate 分流: **放在 unconfigured 之前** ──
    //   顺序理由: `checkConfig()` 会打 `/ziiven/scheduler/config-check` 这个 API。
    //   访客 / 无权用户打它必然 403, `checkConfig()` 的 catch 会把 `unconfigured` 置 true,
    //   于是他们看到的是「系统没配置」的整页提示 —— 跟真实故障长得一模一样, 正是需求一要消灭的那件事。
    //   ⇒ 先分流, 提示页用户根本不会走到 unconfiguredView()。
    //
    //   ⚠️ `state === 'allow'` 时继续往下走原有逻辑, 一行没改。
    //   ⚠️ gate 页**不渲染任何 tab 内容**, 内容门仍由 normalView() 的 tabPermission() 把关。
    const gate = this.effectiveGate();
    if (gate) {
      return this.gateView(gate);
    }

    // v0.18.18 — 逃生口生效 (访客在页面未刷新的情况下登录成功) ⇒ 这时才补上前面被跳过的两个 API。
    //   幂等 (内部有 `_dataLoadingStarted` 闸), 且只在极罕见的这条路径上才会真正发请求。
    if (!this._dataLoadingStarted) {
      this._startDataLoads();
    }

    // v0.5.8 — 未配置 → 整页提示 (header / nav tabs 全部隐藏)
    if (this.unconfigured) {
      return this.unconfiguredView();
    }
    return this.normalView();
  }
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/components/SchedulerIndexPage', SchedulerIndexPage);